import type { SVGProps } from 'react';

const SvgPrinter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M18 7V4c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v3c-1.65 0-3 1.35-3 3v5c0 1.65 1.35 3 3 3h1v2c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-2h1c1.65 0 3-1.35 3-3v-5c0-1.65-1.35-3-3-3M8 5h8v2H8zm7 14H9v-5h6zm4-4c0 .55-.45 1-1 1h-1v-3c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v3H6c-.55 0-1-.45-1-1v-5c0-.55.45-1 1-1h12c.55 0 1 .45 1 1z"
    />
  </svg>
);
export default SvgPrinter;
